import { useAuth } from '../contexts/AuthContext';

import type { AppRole } from '../types/auth';
import type { FormFieldVisibilityContext } from '../utils/formFieldVisibility';

export function useFormFieldVisibilityContext(options?: {
  showFullDetails?: boolean;
  requestStage?: string | null;
  requestId?: string | number | null;
}): FormFieldVisibilityContext {
  const { user } = useAuth();

  return {
    showFullDetails: options?.showFullDetails,
    requestStage: options?.requestStage ?? undefined,
    requestId:
      options?.requestId != null ? String(options.requestId) : undefined,
    userRoles: (user?.roles ?? []) as AppRole[],
    userEmail: user?.email,
  };
}
